<template>
    <div class="webTitle">{{title}}</div>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style lang="scss" scoped>
    .webTitle {
        text-align: center;
        font-size: 24px;
        color: #414a60;
    }
    .webTitle::before {
        content: '';
        display: inline-block;
        vertical-align: 8px;
        margin: 0 10px;
        width: 50px;
        height: 1px;
        background: #d1d4db;
    }
    .webTitle::after {
        content: '';
        display: inline-block;
        vertical-align: 8px;
        margin: 0 10px;
        width: 50px;
        height: 1px;
        background: #d1d4db;
    }
</style>


// WEBPACK FOOTER //
// src/components/webTitle/index.vue